import type { Emotion, EmotionStat } from "~/types/Emotion";

export const useEmotions = () => {
    const getEmotions = () => {
        return useAsyncData<{data: Emotion[]}>('emotions', () => $api('/api/emotions'))
    }

    const sendEmotions = async (chapterUuid: string, emotionIds: number[]) => {
        return await $api(`/api/chapter/${chapterUuid}/emotions`, {
            method: 'POST',
            body: {
                emotion_ids: emotionIds
            }
        })
    }

    const getEmotionStats = async (chapterUuid: string) => {
        const { data, refresh } = await useAsyncData<{data: EmotionStat[]}>(`emotions-stats:${chapterUuid}`, () => $api(`/api/chapter/${chapterUuid}/emotions-stats`), {
            immediate: false
        })
        await refresh()
        return data.value?.data ?? []
    }

    const getMyEmotions = async (chapterUuid: string) => {
        const { data } = await useAsyncData<{data: Emotion[]}>(`my-emotions:${chapterUuid}`, () => $api(`/api/chapter/${chapterUuid}/my-emotions`))
        return data.value?.data ?? []
    }

    return {
        getEmotions,
        sendEmotions,
        getEmotionStats,
        getMyEmotions
    }
}
